import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  isAuthenticated as checkIsAuthenticated,
  getUserDetails,
} from "../services/Auth/authService";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAuthStatus = async () => {
      try {
        const authStatus = checkIsAuthenticated();
        if (authStatus) {
          let authToken = localStorage.getItem("token");
          if (authToken) {
            setToken(authToken);
          }

          const userDetails = await getUserDetails();
          setUser(userDetails);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error("Error checking authentication status:", error);
      }
      setIsLoading(false);
    };

    fetchAuthStatus();
  }, [token]); // ✅ Re-run when token changes

  // ✅ Listen for logout events
  useEffect(() => {
    const handleAuthChange = () => {
      setUser(null);
      setToken(null);
      navigate("/login", { replace: true });
    };

    window.addEventListener("authChange", handleAuthChange);
    return () => window.removeEventListener("authChange", handleAuthChange);
  }, [navigate]);

  // ✅ Logout function updates state properly
  const logout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    setUser(null);
    setToken(null);
    navigate("/login", { replace: true });
  };

  return (
      <AuthContext.Provider
          value={{
            user,
            token,
            isAuthenticated: !!user,
            isLoading,
            setUser,
            setToken,
            logout,
          }}
      >
        {children}
      </AuthContext.Provider>
  );
};
